import Swiper, { Navigation, Pagination, Autoplay, Keyboard} from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, Keyboard]);


const swBreakPoint = 1200;
const swiperBullets = document.querySelector('.swiper-advert-pagination');

function getDirection() {
    const direction = window.innerWidth <= swBreakPoint ? 'horizontal' : 'vertical';
    return direction;
}


window.addEventListener('resize', () => {
    const windowSize = window.innerWidth

    if (windowSize <= swBreakPoint) {
        swiperBullets.classList.add('swiper-pagination-horizontal');
        swiperBullets.classList.remove('swiper-pagination-vertical');
    }

    if (windowSize > swBreakPoint ) {

        if(swiperBullets!==null) {
            swiperBullets.classList.remove('swiper-pagination-horizontal');
            swiperBullets.classList.add('swiper-pagination-vertical');
        }

    }

});


const swOptions = {
    direction: getDirection(),
    slidesPerView: 1,
    spaceBetween: 50,
    loop: true,
    keyboard: {
        enabled: true
    },
    navigation: {
        nextEl: ".arrow--left-ad",
        prevEl: ".arrow--right-ad",
    },
    pagination: {
        el: ".swiper-advert-pagination",
        clickable: true
    },
    on: {
        resize: function () {
            swiperAdvertBannerSlider.changeDirection(getDirection());
        },
    }
};

const swiperAdvertBannerSlider = new Swiper('.swiper.block-advert-banner-rotator__wrapper', swOptions);


